"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const RemoteDialogControllerImpl_1 = tslib_1.__importDefault(require("../deprecated/RemoteDialogControllerImpl"));
const DialogWrapper_1 = tslib_1.__importDefault(require("../deprecated/DialogWrapper"));
const DialogContentWrapper_1 = tslib_1.__importDefault(require("../dialog/DialogContentWrapper"));
const DialogAction_1 = require("../decoratedDialog/DialogAction");
class ModuleContextWrapper {
    constructor(remoteModuleContext, module) {
        this.remoteModuleContext = remoteModuleContext;
        this.module = module;
        // Intentionally left empty
    }
    getModuleConfiguration() {
        return this.moduleConfiguration;
    }
    setModuleConfiguration(moduleConfiguration) {
        this.moduleConfiguration = moduleConfiguration;
    }
    setConfiguration(configuration) {
        this.configuration = configuration;
    }
    getConfiguration() {
        return this.configuration;
    }
    setPatient(patient) {
        this.patient = patient;
    }
    getPatient() {
        return this.patient;
    }
    selectPatient(cpr) {
        this.remoteModuleContext.selectPatient(cpr);
    }
    getPatientConsents(cpr) {
        return this.remoteModuleContext.getPatientConsents(cpr);
    }
    addPatientConsent(cpr, patientConsent) {
        this.remoteModuleContext.addPatientConsent(cpr, patientConsent);
    }
    removePatientConsent(cpr, consentType, content) {
        return this.remoteModuleContext.removePatientConsent(cpr, consentType, content);
    }
    getAudiences() {
        return this.module.getAudiences?.() || [];
    }
    getHTTPSessionHeaders() {
        return this.remoteModuleContext.getHTTPSessionHeaders();
    }
    addHTTPSessionHeader(key, value) {
        this.remoteModuleContext.addHTTPSessionHeader(key, value);
    }
    removeHTTPSessionHeader(key) {
        this.remoteModuleContext.removeHTTPSessionHeader(key);
    }
    setApplicationContextId(applicationContextId) {
        this.remoteModuleContext.setApplicationContextId(applicationContextId);
    }
    getApplicationContextId() {
        return this.remoteModuleContext.getApplicationContextId();
    }
    setUserContext(userContext) {
        // Ignored - we now delegate getUserContext() to the remote module context
    }
    getUserContext() {
        return this.remoteModuleContext.getUserContext();
    }
    setReadOnly(readonly) {
        this.readonly = readonly;
    }
    isReadOnly() {
        return this.readonly;
    }
    updateLastAction(lastAction) {
        this.remoteModuleContext.updateLastAction(lastAction);
    }
    setFramed(framed) {
        this.framed = framed;
    }
    isFramed() {
        return this.framed;
    }
    fireFramingEvent(framingEvent) {
        this.remoteModuleContext.fireFramingEvent(framingEvent);
    }
    showTab(tabId) {
        this.remoteModuleContext.showTab(tabId);
    }
    hideTab(tabId) {
        this.remoteModuleContext.hideTab(tabId);
    }
    selectTab(tabId) {
        this.remoteModuleContext.selectTab(tabId);
    }
    updateModuleSpecificStatusBarInfo(moduleSpecificBarInfo) {
        this.remoteModuleContext.updateModuleSpecificStatusBarInfo(moduleSpecificBarInfo);
    }
    updateModuleSpecificStatusElement(widget) {
        this.remoteModuleContext.updateModuleSpecificStatusElement(widget);
    }
    refreshDashboardButton(buttonId) {
        this.remoteModuleContext.refreshDashboardButton(buttonId);
    }
    openDialog(html, handler) {
        const remoteHandler = new RemoteDialogControllerImpl_1.default(handler, this.uncaughtExceptionHandler);
        const remoteDialog = this.remoteModuleContext.openDialog(html, remoteHandler);
        return new DialogWrapper_1.default(remoteDialog);
    }
    async showDialog(viewableDialog, options) {
        const dialogManager = this.getDialogManager();
        return new Promise((resolve, reject) => {
            // Dig out buttons that were added on prototype by decorator:
            const dialogButtons = viewableDialog.constructor.prototype.dialogButtons ?? [];
            const buttons = dialogButtons.map(buttonOptions => {
                buttonOptions.button = this.remoteModuleContext.createDialogButton(buttonOptions.style, buttonOptions.label);
                return buttonOptions.button;
            });
            const dialogButtonActions = viewableDialog.constructor.prototype.dialogButtonActions ?? [];
            //
            let closeButton;
            dialogButtonActions.map(action => {
                const { targetButton, fn, passErrors, keepOpenOnResolve } = action;
                const button = targetButton.button;
                if (targetButton.close) {
                    button.element.addEventListener("click", () => {
                        const prevEnabled = !!closeButton?.isEnabled();
                        button.setEnabled(false);
                        try {
                            fn.apply(viewableDialog);
                        }
                        catch (e) {
                            reject(e);
                        }
                        button.setEnabled(prevEnabled);
                    });
                }
                else {
                    button.element.addEventListener("click", async () => {
                        const prevEnabled = button.isEnabled();
                        button.setEnabled(false);
                        try {
                            const value = await fn.apply(viewableDialog);
                            if (value === DialogAction_1.DialogActionReturnValue.REBOUND) {
                                return;
                            }
                            resolve(value);
                            if (!keepOpenOnResolve) {
                                dialogManager.hide();
                            }
                        }
                        catch (e) {
                            if (passErrors) {
                                reject(e);
                                dialogManager.hide();
                            }
                            else {
                                // Report as an unexpected error and keep dialog open
                                this.uncaughtExceptionHandler(e);
                            }
                        }
                        finally {
                            button.setEnabled(prevEnabled);
                        }
                    });
                }
            });
            const dialogActions = viewableDialog.constructor.prototype.dialogActions ?? [];
            const additionalButtons = dialogActions.map(action => {
                if (action.close) {
                    closeButton = this.remoteModuleContext.createDialogButton(action.style, action.label, () => {
                        const prevEnabled = !!closeButton?.isEnabled();
                        closeButton?.setEnabled(false);
                        try {
                            action.fn.apply(viewableDialog);
                        }
                        catch (e) {
                            reject(e);
                        }
                        closeButton?.setEnabled(prevEnabled);
                    });
                    return closeButton;
                }
                else {
                    const dialogButton = this.remoteModuleContext.createDialogButton(action.style, action.label, async () => {
                        const prevEnabled = dialogButton.isEnabled();
                        dialogButton.setEnabled(false);
                        try {
                            const value = await action.fn.apply(viewableDialog);
                            if (value === DialogAction_1.DialogActionReturnValue.REBOUND) {
                                return;
                            }
                            resolve(value);
                            if (!action.keepOpenOnResolve) {
                                dialogManager.hide();
                            }
                        }
                        catch (e) {
                            if (action.passErrors) {
                                reject(e);
                                dialogManager.hide();
                            }
                            else {
                                // Report as an unexpected error and keep dialog open
                                this.uncaughtExceptionHandler(e);
                            }
                        }
                        finally {
                            dialogButton.setEnabled(prevEnabled);
                        }
                    });
                    dialogButton.setVisible(!action.visibleWhen || action.visibleWhen());
                    return dialogButton;
                }
            });
            buttons.push(...additionalButtons);
            const dialogContent = new DialogContentWrapper_1.default(viewableDialog, buttons, () => {
                // Dialog was closed by one of the methods we have for that (hit ESC, click cross, click close button)
                resolve(null);
            }, closeButton);
            dialogManager.show(dialogContent, options);
        });
    }
    getDialogManager() {
        return this.remoteModuleContext.getDialogManager(this.uncaughtExceptionHandler);
    }
    addPendingRequest(description) {
        return this.remoteModuleContext.addPendingRequest(description);
    }
    handleUnauthorized(tryPassiveLogin, onSuccess) {
        this.remoteModuleContext.handleUnauthorized(tryPassiveLogin, onSuccess);
    }
    isLoginEstablished() {
        return this.remoteModuleContext.isLoginEstablished();
    }
    loadSubModuleStylesheetInParent(stylesheetPath) {
        this.remoteModuleContext.loadSubModuleStylesheetInParent(stylesheetPath);
    }
    restartApplication() {
        this.remoteModuleContext.restartApplication();
    }
    switchRoleAndOrganisation() {
        this.remoteModuleContext.switchRoleAndOrganisation();
    }
    setHistoryToken(historyToken) {
        this.historyToken = historyToken;
    }
    getHistoryToken() {
        return this.historyToken;
    }
    getModuleName() {
        return this.module.getName();
    }
    getModuleScriptName() {
        return this.module.getScriptName();
    }
    setUncaughtExceptionHandler(uncaughtExceptionHandler) {
        this.uncaughtExceptionHandler = uncaughtExceptionHandler;
    }
    getUncaughtExceptionHandler() {
        return this.uncaughtExceptionHandler;
    }
    getRootElement() {
        return this.remoteModuleContext.getRootElement(this.module.getName());
    }
}
exports.default = ModuleContextWrapper;
//# sourceMappingURL=ModuleContextWrapper.js.map